/**
 * Models a menu item node. Its properties reflect a Router5 configuration and
 * RVC's' API requirements per BugzId:71990
 *
 * Added a new `hidden` property per BugzId:72846 - This duplicates the purpose
 * of `deleted` -- If either flag is true, the menu item is removed from the
 * final collection to be used by the implementing view.
 */

import Brace from "backbone.brace";

const Model = Brace.Model.extend({
  idAttribute: "name",

  namedAttributes: {
    id: Number,
    parentId: Number,
    active: Boolean,
    // calculated - from route path
    name: String,
    // calculated - title of parent node
    title: String,
    // calculated by Routable behavior
    category: String,
    // menu label
    label: String,
    // alt text
    description: String,
    // route path, i.e. /plans
    path: String,
    // optional - when present it used instead of route path
    url: String,
    // data params required by API
    data: Object,
    originalData: Object,
    // internal - identifies the type of link
    // "Global, Private, Shared are the 3 values now"-Matt
    linkAccessScopeType: String,
    // other flags added by Matt
    createdBy: String,
    createdTimestamp: Date,
    lastModifiedBy: String,
    lastModifiedTimestamp: Date,
    // indicates whether this item is to be hidden
    hidden: Boolean,
    deletedBy: String,
    deletedTimestamp: Date,
    // not sure what this means anymore... see notes above
    deleted: Boolean,
    // indicates whether this item is enabled
    enabled: Boolean,
    // indicates if should be treated as default report
    defaultRoute: Boolean,
    // fontawesome icon
    icon: String,
    children: Array,
    value: String,
    external: Boolean,
    current: Boolean,
    divider: Boolean,
    className: String,
  },

  defaults: {
    id: null,
    parentId: null,
    active: false,
    name: null,
    title: "RVC",
    category: null,
    label: null,
    description: null,
    path: null,
    url: null,
    data: null,
    originalData: null,
    linkAccessScopeType: null,
    createdBy: null,
    createdTimestamp: null,
    lastModifiedBy: null,
    lastModifiedTimestamp: null,
    hidden: false,
    deletedBy: null,
    deletedTimestamp: null,
    deleted: null,
    enabled: true,
    defaultRoute: null,
    icon: null,
    children: [],
    value: null,
    external: false,
    current: false,
    divider: false,
    className: null,
  },
});

export { Model as default };
